import { authApiService } from '../../authApiService';
import { ApiResponseType, ForgotPasswordResponseType } from '@/types/sharedTypes';

export const forgotPasswordCheckPinCodeApi = async (data): Promise<ApiResponseType<ForgotPasswordResponseType>> => {
  const uri = '/users/forgot-password/pin/';

  return authApiService.POST(uri, data);
};
